import React,{useContext} from 'react';

import { ThemeContext } from '../../contexts/ThemeContext';

import './Experience.css';

import { experienceData } from '../../data/experienceData'
import ExperienceCard from './ExperienceCard';

function Experience() {

    const { theme } = useContext(ThemeContext);
    return (
        <div className="experience" id="experience" style={{backgroundColor: theme.secondary}}> 
             <div className="experience-body">
                 <div className="experience-description">
                    <p className='section-kicker'>Experience</p>
                    <h1 style={{color:theme.primary}}>Career highlights and leadership</h1>
                    {experienceData.map(exp =>(
                        <ExperienceCard 
                            key={exp.id}
                            id={exp.id}
                            jobtitle={exp.jobtitle}
                            company={exp.company}
                            startYear={exp.startYear}
                            endYear={exp.endYear}
                            summary={exp.summary}/>
                    ))}
                 </div>
                 <div className="experience-image">
                     <img src={theme.expimg} alt="Experience visual" />
                 </div>
             </div>
        </div>
    )
}

export default Experience
